import React from 'react'
import './styles.css'
import {
  defineMessages,
  FormattedMessage
} from 'react-intl'
import Modal from 'components/Modal'
import Button from 'components/Button'
import { ERROR } from 'constants/unconnectedVisitReasons'
import { VISIT_UNCONNECTED_MODAL, SEND_MESSAGE_MODAL } from 'constants/modals'
import {isVisManager} from 'utils/visManager'
import { sendGAClickEvent } from 'utils/googleAnalytics'
import { isRemoteVisitor } from 'utils/user'
import LoadingSpinner from 'components/LoadingSpinner'
import { VIGNETTE_UNSUPPORTED_IOS, VIGNETTE_UNSUPPORTED_ANDROID } from 'utils/vignetteOSChecker'

const messages = defineMessages({
  close: 'Close',
  sendMessage: 'Send Message',
  visitMissedTitle: 'Video Visit',
  visitMissedBody: 'Sorry your visit was missed',
  visitDeclinedTitle: 'Video Visit',
  visitDeclinedBody: 'Participant declined the visit',
  visitErrorTitle: 'Sorry, there was an issue with your visit.',
  visitErrorDefaultBody: 'Please call Customer Service (866) 516-0115',
  'participant_disconected': 'Participant has disconnected.',
  'creating_visit_failed': 'Failed to create video visit.',
  'visit_not_started_for_30_seconds': 'Failed to start video visit.',
  'invalid_appointment_id': 'Visit has been finished.',
  [VIGNETTE_UNSUPPORTED_IOS]: 'Visitation requires iOS 16 or greater, please upgrade your iOS.',
  [VIGNETTE_UNSUPPORTED_ANDROID]: 'Visitation requires Android OS 11 or greater, please upgrade your Android OS.',
  textMessageCostRetrievalFailure: 'Failed to retrieve the cost of the message.'
})

function UnconnectedVisitModal(props) {
  const {
    show,
    openModal,
    closeModal,
    redirectURL,
    reason,
    clearError,
    errorMessage,
    messagingEnabled,
    getTextMessageCost,
    costError,
    loading,
    isInitiator,
    declineVisit,
    cancelVisit
  } = props

  if (!reason) return null

  let bodyMessage = ''
  if (reason === ERROR) {
    bodyMessage = errorMessage && messages[errorMessage] || messages.visitErrorDefaultBody
  } else {
    bodyMessage = messages[`${reason}Body`]
  }
  const sendMsgEnabled = !isVisManager() && messagingEnabled && isRemoteVisitor()

  const handleClose = () => {
    sendGAClickEvent('CTA_Close_Visit_Modal')
    closeModal(VISIT_UNCONNECTED_MODAL)
    clearError()
    if (redirectURL) {
      window.location.replace(redirectURL)
    }
  }

  const doDeclineVisit = () => {
    if (isInitiator) {
      cancelVisit(handleClose)
    } else {
      declineVisit(handleClose)
    }
  }

  const onClose = () => {
    if ([VIGNETTE_UNSUPPORTED_IOS, VIGNETTE_UNSUPPORTED_ANDROID].includes(errorMessage)) {
      doDeclineVisit()
    } else {
      handleClose()
    }
  }

  return (
    <Modal
      title={(<FormattedMessage {...messages[`${reason}Title`]} />)}
      show={show}
      footer={(
        <>
          { sendMsgEnabled && costError && (
            <div styleName='error'><FormattedMessage {...messages.textMessageCostRetrievalFailure} /></div>
          )}
          { sendMsgEnabled && (
            <Button
              type='go'
              onClick={() => {
                if (loading) return
                sendGAClickEvent('CTA_Voicemail_Msg_Initiate')
                getTextMessageCost(() => {
                  closeModal(VISIT_UNCONNECTED_MODAL)
                  openModal(SEND_MESSAGE_MODAL)
                })
              }}
            >
              {
                loading
                  ? <LoadingSpinner color='white' size='25px' />
                  : <FormattedMessage {...messages.sendMessage} />
              }
            </Button>
          )}
          <Button
            type='ok'
            onClick={onClose}
          >
            <FormattedMessage {...messages.close} />
          </Button>
        </>
      )}
    >
      <div styleName='body'>
        {<FormattedMessage {...bodyMessage}/>}
      </div>
    </Modal>
  )
}

export default UnconnectedVisitModal
